import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import * as DOMPurify from 'dompurify';
import Axios from 'axios';
import { useEffect, useState } from 'react'
import { domain } from '../env';
import { useParams } from 'react-router-dom';

export const Scarsvdetails = () => {
    const [scarsvall, setScarsvall] = useState(null);
    const [relatedPosts, setRelatedPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const { id } = useParams();

    // Fetch single scarsv detail
    const getScarsvdetail = async () => {
        setLoading(true);
        try {
            const response = await Axios.get(`${domain}/api/scarsv/${id}/`);
            setScarsvall(response.data);
            console.log(response.data, "scarsv detail data");
            
            // After getting details, fetch related posts
            getRelatedPosts();
        } catch (error) {
            console.error("Error fetching scarsv detail:", error);
        } finally {
            setLoading(false);
        }
    };

    // Fetch related posts (limit to 3)
    const getRelatedPosts = async () => {
        try {
            const response = await Axios.get(`${domain}/api/scarsv/?page=1`);
            // Make sure we're working with an array and filter out the current post
            if (response.data && response.data.results && Array.isArray(response.data.results)) {
                const filteredPosts = response.data.results.filter(post => post.id !== parseInt(id));
                setRelatedPosts(filteredPosts.slice(0, 3));
            }
        } catch (error) {
            console.error("Error fetching related posts:", error);
        }
    };

    useEffect(() => {
        getScarsvdetail();
        window.scrollTo(0, 0);
    }, [id]); // Re-fetch when ID changes

    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (!scarsvall) {
        return <div className="container mt-5 text-center">Post not found</div>;
    }

    return (
        <>
            <section className="page-header">
                <div className="page-header-bg" style={{ 'backgroundImage': 'url(/images/v.jpg)' }}>
                </div>
                <div className="container">
                    <div className="page-header__inner">
                        <h2>{scarsvall.title_english || "ACTIVITIES DETAIL"}</h2>
                        <ul className="thm-breadcrumb list-unstyled">
                            <li><a href="/">Home</a></li>
                            <li><span>/</span></li>
                            <li><a href="/scarsv">Activities</a></li>
                            <li><span>/</span></li>
                            <li className="active">Detail</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="news-details">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="news-details__left">
                                <div className="news-details__img">
                                    <LazyLoadImage
                                        effect="blur"
                                        src={`${domain}${scarsvall.image}`}
                                        alt={scarsvall.title_english}
                                        width="100%"
                                        height="auto"
                                    />
                                    <div className="news-details__date">
                                        <p>{scarsvall.createdat}</p>
                                    </div>
                                </div>
                                <div className="news-details__content">
                                    <h3 className="news-details__title">{scarsvall.title_english}</h3>
                                    <div className="news-details__text" 
                                         dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(scarsvall.details_English) }} />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5">
                            <div className="sidebar">
                                <div className="sidebar__single sidebar__post">
                                    <h3 className="sidebar__title">Recent Posts</h3>
                                    <ul className="sidebar__post-list list-unstyled">
                                        {relatedPosts.map((post) => (
                                            <li key={post.id}>
                                                <div className="sidebar__post-image">
                                                   <LazyLoadImage 
                                                        effect="blur"
                                                        src={`${domain}${post.image}`}
                                                        alt={post.title_english}
                                                        style={{ width: '150px', height: '80px', objectFit: 'cover' }}
                                                    />

                                                </div>
                                                <div className="sidebar__post-content">
                                                    <h3>
                                                        <a href={`/scarsvdetails${post.id}`}
                                                           className="sidebar__post-content-meta">
                                                            <i className="far fa-calendar-alt"></i> {post.createdat}
                                                        </a>
                                                        <a href={`/scarsvdetails${post.id}`}>{post.title_english}</a>
                                                    </h3>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
